import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ConsentContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #0a1428 0%, #1e3a5f 100%);
  border-top: 3px solid #4A9EFF;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 0.5s ease-out;
  
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const ConsentContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  position: relative;
  
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1.5rem 1rem;
    gap: 1rem;
    text-align: center;
  }
`;

export const ConsentText = styled.div`
  color: #ffffff;
  font-size: 0.95rem;
  line-height: 1.5;
  flex: 1;
  
  strong {
    color: #4A9EFF;
    font-size: 1.1rem;
  }
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }
`;

export const ConsentButtons = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.8rem;
  }
`;

export const AcceptButton = styled.button`
  background: linear-gradient(135deg, #4A9EFF 0%, #357ABD 100%);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  
  &:hover {
    background: linear-gradient(135deg, #357ABD 0%, #2A5F94 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);
  }
  
  @media (max-width: 480px) {
    width: 100%;
    padding: 1rem;
  }
`;

export const DeclineButton = styled.button`
  background: transparent;
  color: #B8C5D1;
  border: 2px solid #B8C5D1;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  
  &:hover {
    background: #B8C5D1;
    color: #0a1428;
    transform: translateY(-2px);
  }
  
  @media (max-width: 480px) {
    width: 100%;
    padding: 1rem;
  }
`;

export const PolicyLink = styled.a`
  color: #4A9EFF;
  text-decoration: underline;
  font-weight: 600;
  transition: color 0.3s ease;
  
  &:hover {
    color: #357ABD;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  background: none;
  border: none;
  color: #B8C5D1;
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.3s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #ffffff;
  }
  
  @media (max-width: 768px) {
    top: 0.8rem;
    right: 0.8rem;
  }
`;